/**
 * Delete Distributor Form Schema
 */

import { z } from 'zod'
import { FormConfigLoader } from '@/lib/formConfigLoader'
import formYaml from './form.yml?raw'

const formConfig = FormConfigLoader.loadFormConfig(formYaml)

export const FORM_CONFIG = formConfig
export const FORM_NAME = formConfig.formName
export const FORM_TITLE = formConfig.formTitle
export const FORM_DESCRIPTION = formConfig.formDescription

const MIN_NUMBER = 1000000000
const MAX_NUMBER = 9999999999

export const DeleteDistributorFormSchema = z.object({
  distributorNumber: z
    .number()
    .gte(MIN_NUMBER)
    .lte(MAX_NUMBER),
  distributorName: z
    .string()
    .min(1, 'Distributor name is required'),
})

export type DeleteDistributorFormData = z.infer<typeof DeleteDistributorFormSchema>

export function transformToApiRequest(formData: DeleteDistributorFormData) {
  return {
    distributorNumber: formData.distributorNumber,
  }
}
